import { StatsigClient } from '@statsig/react-bindings';

export function logEvent(eventName: string, metadata?: Record<string, string>): void {
  try {
    StatsigClient.instance().logEvent(eventName, undefined, metadata);
  } catch {
    // client not yet initialized — event is dropped intentionally
  }
}
